import { render, staticRenderFns } from "./HospitalSend.vue?vue&type=template&id=b0aa4e76&scoped=true"
import script from "./HospitalSend.vue?vue&type=script&lang=js"
export * from "./HospitalSend.vue?vue&type=script&lang=js"
import style0 from "./HospitalSend.vue?vue&type=style&index=0&id=b0aa4e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aa4e76",
  null
  
)

export default component.exports